import styled from "styled-components"

export const GoogleButton = styled.button`
  display: flex;
  flex-direction: row;
  width: 100%;
  border-radius: 10rem;
  align-items: center;
  justify-content: center;
  border: 1px solid #00000033;
  padding: 1.5rem 1rem;
  text-transform: uppercase;
  color: #000;
  font-family: "Maax", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 500;
  font-size: 16px;
  opacity: 0.8;
  height: 4.85rem !important;

  &:hover {
    opacity: 1;
  }

  svg {
    margin: 0 1rem 0 0;
  }
`

export const FormEl = styled.form`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`

export const Input = styled.input`
  padding: 1.5rem 1rem;
  border-radius: 10rem;
  border: 1px solid #00000033 !important;
  height: 4.85rem !important;
  background-color: #fff !important;
  font-weight: 400;
  font-family: "Maax", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 1.5rem !important;
  color: #222 !important;
  opacity: 0.8;

  &:hover {
    opacity: 1;
  }
`

export const SubmitButton = styled.button`
  padding: 1.5rem 1rem;
  border-radius: 10rem;
  height: 4.85rem !important;
  background-color: #003445;
  font-weight: 500;
  font-family: "Maax", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 1.5rem !important;
  color: #fff;
  width: 100%;
  text-transform: uppercase;
  opacity: 0.9;

  &:hover {
    opacity: 1;
  }
`

export const GoogleIcon = styled.div`
  padding: 0 1rem;
  display: flex;
  align-items: center;
  background-color: #fff;
  margin: 0 1rem 0 0;
  padding: 1rem;
`

export const Line = styled.div`
  position: relative;
  margin: 3.5rem 0;
  text-align: center;

  :before {
    content: " ";
    position: absolute;
    top: 50%;
    left: 0;
    width: 42%;
    height: 0.08rem;
    background-color: #00000033;
  }

  :after {
    content: " ";
    position: absolute;
    top: 50%;
    right: 0;
    width: 42%;
    height: 0.08rem;
    background-color: #00000033;
  }
`

export const OrLabel = styled.div`
  color: #000;
  font-size: 1.2rem;
  font-weight: 500;
  font-family: "Maax", "Helvetica Neue", Helvetica, Arial, sans-serif;
`
